module.exports = __webpack_public_path__ + "img/alipay.259f8eea.svg";